module.exports = __webpack_public_path__ + "static/gogolook-logo-6dc0e1619ca2d7c3dc5e4e5f06b2c967.svg";